<template>
  <el-dialog
    title=""
    :visible.sync="dialogVisible"
    width="500px"
    top="30vh"
    @close="onCancel"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="110px"
      label-position="right"
      size="medium"
      style="padding: 20px 20px 0;"
    >
      <el-form-item label="导出日期范围" prop="dateRange">
        <el-date-picker
          v-model="form.dateRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="width-max"
          clearable
        />
      </el-form-item>
      <el-form-item label="导出邮件类型" prop="type">
        <el-select v-model="form.type" placeholder="请选择" class="width-max">
          <el-option label="生日祝福邮件" :value="2" />
          <el-option label="入职周年庆邮件" :value="1" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" :loading="loading" @click="onConfirm">确定</el-button>
      <el-button @click="onCancel">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EmailExportDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      form: {
        dateRange: [],
        type: null,
      },
      rules: {
        dateRange: [
          { required: true, message: '请选择导出日期范围', trigger: 'change' },
        ],
        type: [
          { required: true, message: '请选择导出邮件类型', trigger: 'change' },
        ],
      },
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      },
    },
  },
  methods: {
    onCancel () {
      this.dialogVisible = false
      this.resetForm()
      this.$emit('cancel')
    },
    onConfirm () {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        const [startDate, endDate] = this.form.dateRange || []
        this.$emit('confirm', {
          start_at: startDate,
          end_at: endDate,
          type: this.form.type,
        })
      })
    },
    resetForm () {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      } else {
        this.form.dateRange = []
        this.form.type = null
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/hr/components/EmailExportDialog.vue